import { render } from "./AccessProcess.vue?vue&type=template&id=43248a8e&scoped=true"
import script from "./AccessProcess.vue?vue&type=script&lang=js"
export * from "./AccessProcess.vue?vue&type=script&lang=js"

import "./AccessProcess.vue?vue&type=style&index=0&id=43248a8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43248a8e"]])

export default __exports__